var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"input-value":_vm.checked,"label":"Show hidden providers"},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }